import { AdvisorOrganizationData, RESET_ADV_REPORT_FORM, SUBMIT_ADV_REPORT_FORM } from './types';

const initialState = {
  advisorReportOrganizations: [],
  formValues: {},
  isFormSubmitted: false
};
export const advisorReportOrganization = (
  state: AdvisorOrganizationData = initialState,
  action: {
    type: string;
    payload?: Record<string, string | number>;
  }
): AdvisorOrganizationData => {
  switch (action.type) {
    case SUBMIT_ADV_REPORT_FORM:
      return {
        ...state,
        formValues: { ...state.formValues, ...(action.payload ?? {}) },
        isFormSubmitted: true
      };
    case RESET_ADV_REPORT_FORM:
      return initialState;
    default:
      return state;
  }
};
